import React from "react"

const Spacer = () => (
  <div className="spacer panel--w-half panel--h-screen"></div>
)

export default Spacer
